export default function() {
    return {
        trips: [],
        orders: [],
        passengers: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        searchParams: {
            eventTitle: '',
            timeTrips: 'after'
        },
        showDeleteConfirmation: false,
        currentTripDelete: null,
        apiUrl: process.env.VUE_APP_API_URL,
        fields: [
            {
                key: 'cover',
                label: 'Imagem'
            },
            {
                key: 'eventTitle',
                label: 'Nome'
            },
            {
                key: 'durationDateText',
                label: 'Data'
            },
            {
                key: 'totalVacancies',
                label: 'Total de vagas'
            },
            {
                key: 'pageViews',
                label: 'Visualizações'
            },
            {
                key: 'actions',
                label: 'Opções'
            }
        ],
        blockRemoval: [],
        notDelete: false,
        showVacancy: false,
        currentAlertSuccessVacancy: 0,
        currentAlertDangerVacancy: 0,
        currentAccommodations: [],
        currentTrip: {}
    }
}
